import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "bg-white shadow-lg rounded-xl p-6 font-inter border border-gray-200" };
const _hoisted_2 = {
    key: 0,
    class: "mb-4 p-4 bg-red-50 border border-red-200 rounded-lg"
};
const _hoisted_3 = { class: "text-red-800 font-medium" };
const _hoisted_4 = {
    key: 1,
    class: "space-y-4"
};
const _hoisted_5 = { class: "space-y-4" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = {
    key: 0,
    class: "flex items-center justify-center"
};
const _hoisted_8 = {
    key: 1,
    class: "flex items-center justify-center"
};
const _hoisted_9 = {
    key: 3,
    class: "mt-6 p-4 bg-green-50 border border-green-200 rounded-lg"
};
const _hoisted_10 = { class: "text-green-700" };
import PayPalCheckout from './PayPalCheckout.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderSubmitButton',
    props: {
        canSubmit: { type: Boolean },
        isLoading: { type: Boolean },
        totalAmount: {},
        formatPrice: { type: Function },
        error: {},
        orderSuccess: { type: Boolean },
        orderNumber: {},
        paymentMethod: {},
        orderData: {}
    },
    emits: ["submit", "paypal-success", "paypal-error"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        function handleSubmit() {
            emit('submit');
        }
        function handlePayPalSuccess(paymentData) {
            console.log('PayPal payment successful:', paymentData);
            emit('paypal-success', paymentData);
        }
        function handlePayPalError(error) {
            console.error('PayPal payment error:', error);
            emit('paypal-error', error);
        }
        function handlePayPalCancel() {
            console.log('PayPal payment was cancelled by user');
            // Optional: Show user feedback about cancelled payment
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                (_ctx.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.error), 1 /* TEXT */)
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" PayPal Payment "),
                (_ctx.paymentMethod === 'paypal' && !_ctx.orderSuccess)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-center text-gray-600 text-sm mb-4" }, [
                            _createElementVNode("p", null, "Bezahle sicher mit PayPal oder Karte"),
                            _createElementVNode("p", { class: "text-xs mt-1" }, "Du wirst nach der Bestätigung zu PayPal weitergeleitet")
                        ], -1 /* CACHED */)),
                        _createVNode(PayPalCheckout, {
                            amount: _ctx.totalAmount.toFixed(2),
                            currency: "EUR",
                            "order-data": {
                                ..._ctx.orderData,
                                totalAmount: _ctx.totalAmount,
                                orderDetails: {
                                    subtotal: (_ctx.totalAmount - (_ctx.orderData?.deliveryFee || 0) - (_ctx.orderData?.serviceFee || 0)),
                                    deliveryFee: (_ctx.orderData?.deliveryFee || 0),
                                    serviceFee: (_ctx.orderData?.serviceFee || 0),
                                    total: _ctx.totalAmount
                                }
                            },
                            onPaymentSuccess: handlePayPalSuccess,
                            onPaymentError: handlePayPalError,
                            onPaymentCancel: handlePayPalCancel
                        }, null, 8 /* PROPS */, ["amount", "order-data"]),
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-center text-xs text-gray-500" }, [
                            _createElementVNode("p", null, "Gesichert durch PayPal. Keine versteckten Kosten.")
                        ], -1 /* CACHED */))
                    ]))
                    : (!_ctx.orderSuccess)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createCommentVNode(" Traditional Submit Button for Cash/Card "),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("button", {
                                    onClick: handleSubmit,
                                    disabled: !_ctx.canSubmit || _ctx.isLoading,
                                    class: "w-full bg-red-600 hover:bg-red-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-semibold py-4 px-6 rounded-xl transition-colors shadow-sm border-2 border-red-600 disabled:border-gray-400"
                                }, [
                                    (_ctx.isLoading)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [...(_cache[2] || (_cache[2] = [
                                                _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1 /* CACHED */),
                                                _createTextVNode(" Bestellung wird verarbeitet... ", -1 /* CACHED */)
                                            ]))]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                            _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-shopping-cart mr-2" }, null, -1 /* CACHED */)),
                                            _createTextVNode(" Jetzt bestellen - " + _toDisplayString(_ctx.formatPrice(_ctx.totalAmount)), 1 /* TEXT */)
                                        ]))
                                ], 8 /* PROPS */, _hoisted_6)
                            ])
                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                (_ctx.orderSuccess)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-green-800 font-semibold mb-2" }, "Bestellung erfolgreich!", -1 /* CACHED */)),
                        _createElementVNode("p", _hoisted_10, "Bestellnummer: " + _toDisplayString(_ctx.orderNumber), 1 /* TEXT */),
                        _createVNode(_component_router_link, {
                            to: "/",
                            class: "inline-block mt-3 text-blue-600 hover:text-blue-800 font-medium"
                        }, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                    _createTextVNode("Zur Startseite", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        })
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
